import Shaparak from './Shaparak';

type typePaymentScreen = {
  Shaparak: typeof Shaparak;
}

const PaymentScreen: typePaymentScreen = {
  Shaparak,
}

export default PaymentScreen;
